export default __webpack_public_path__ + "bf8dd8e2969178411dee8cca7e1502ce.jpg";